export enum Pages {
  Services = "/services/:id",
  ValidationForm = "/submit-process/validation-form/:id",
  FinalAnalysisTest = "/submit-process/final-analysis-test/:id",
  AdditionalInformation = "/submit-process/additional-information/:id",
  ServiceSegments = "/submit-process/service-segments/:id/:subServiceId?",
  Result = "/result/:id",
  ResultAI = "/result-ai/:id/:subServiceId?",
  ResultAgency = "/agency/:id/:subServiceId?/:username",
  Share = "/share/:share_token",
  SpecialistProfile = "/specialist/specialist-profile/:id",
  TransactionResult = "/TransactionResult/:status",
  Subscription = "/subscription",
  TokenUsageDetails = "/token-usage-details",
  History = "/history",
  Guide = "/guide",
  Profile = "/profile",
  Transactions = "/wallet-transactions",
  Notifications = "/notifications",
  Portfolio = "/portfolio",
  TokenHistoryDetails = "/token-history-details",
  TermsAndRegulations = "/terms-and-regulations",
  ContactUs = "/contact-us",
  Agencies = "/agencies",
  Agency = "/agency/:username",
  AgencyCreate = "/agency/create",
  AgencyEdit = "/agency/edit/:username",
  AgencyDataList = "/agency/raw-data/list/:username",
  AgencyDataCreate = "/agency/raw-data/create/:username",
}
